"use strict";

exports.__esModule = true;
exports.default = void 0;
var _preact = require("preact");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable react/require-default-props */

function GridListItem(props) {
  var className = props.className,
    isDisabled = props.isDisabled,
    restrictionError = props.restrictionError,
    isChecked = props.isChecked,
    title = props.title,
    itemIconEl = props.itemIconEl,
    showTitles = props.showTitles,
    toggleCheckbox = props.toggleCheckbox,
    recordShiftKeyPress = props.recordShiftKeyPress,
    id = props.id,
    children = props.children;
  var checkBoxClassName = (0, _classnames.default)('uppy-u-reset', 'uppy-ProviderBrowserItem-checkbox', 'uppy-ProviderBrowserItem-checkbox--grid', {
    'uppy-ProviderBrowserItem-checkbox--is-checked': isChecked
  });
  return (0, _preact.h)("li", {
    className: className,
    title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : undefined
  }, (0, _preact.h)("input", {
    type: "checkbox",
    className: checkBoxClassName,
    onChange: toggleCheckbox,
    onKeyDown: recordShiftKeyPress
    // @ts-expect-error this is fine onMouseDown too
    ,

    onMouseDown: recordShiftKeyPress,
    name: "listitem",
    id: id,
    checked: isChecked,
    disabled: isDisabled,
    "data-uppy-super-focusable": true
  }), (0, _preact.h)("label", {
    htmlFor: id,
    "aria-label": title,
    className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
  }, itemIconEl, showTitles && title, children));
}
var _default = exports.default = GridListItem;